{
  "version": 1,
  "asset_id": "e8db0a40-a5d8-480a-a457-7d25210f13f5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e8db0a40-a5d8-480a-a457-7d25210f13f5/dilated-pouch-boxed-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e8db0a40-a5d8-480a-a457-7d25210f13f5/dilated-pouch-boxed-es-800.webp",
  "original_filename": "dilated-pouch-boxed-es-800.webp",
  "size": 38304,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:09:15Z"
}
